import './styling/travelStyling.scss';

import { FC } from 'react';
import { Control, FieldErrors } from 'react-hook-form';
import { Box, Title } from '@gjensidige/builders-components';

import { Datepicker, Dropdown, Input, InputGroup, Textarea } from '../../../components';
import {
  cancellationOccurance,
  cancellationReasonOptions,
  insuranceUserOptions,
  travelPurposeOptions,
} from '../../../constants';
import { EquinorTravelValues } from '../../../utils/types';
import { TravelHeader } from '../components/TravelHeader';
import { PersonDetails } from './PersonDetails';

interface CancellationProps {
  control: Control<EquinorTravelValues>;
  errors: FieldErrors<EquinorTravelValues>;
}

const Cancellation: FC<CancellationProps> = ({ control, errors }) => {
  return (
    <>
      <TravelHeader
        headerTitle="Cancellation"
        description="You have cancelled your trip due to illness, injury, death or other reasons."
      />
      <PersonDetails control={control} errors={errors} />
      <Box variant="form-section" className="form-section">
        <Title as="h4" size="5">
          Claim Details
        </Title>
        <InputGroup
          name="injuredParty"
          control={control}
          labelText="For whom was the trip cancelled?"
          options={insuranceUserOptions}
          type="checkbox"
          variant="column"
          tracking={false}
          error={errors.injuredParty}
        />
        <Textarea
          name="otherImpactedParts"
          control={control}
          labelText="If others than you within your travel party had to cancel their trip, add their names, birthdates, and your relation to them - optional"
          maxWarning={500}
          error={errors.otherImpactedParts}
        />
        <Datepicker
          name="tripStartBookedDate"
          control={control}
          labelText="When was the trip booked? (dd/mm/yyyy)"
          format="dd/MM/yyyy"
          formatDayJs="DD/MM/YYYY"
          error={errors.tripStartBookedDate}
        />
        <Datepicker
          name="tripEndCancelledDate"
          control={control}
          labelText="When was the trip cancelled? (dd/mm/yyyy)"
          format="dd/MM/yyyy"
          formatDayJs="DD/MM/YYYY"
          error={errors.tripEndCancelledDate}
        />
        <InputGroup
          name="travelPurpose"
          control={control}
          labelText="What was the purpose of the trip?"
          options={travelPurposeOptions}
          type="radio"
          variant="column"
          tracking={false}
          error={errors.travelPurpose}
        />
        <Input
          name="cancellation.departureCountry"
          control={control}
          labelText="Country of departure"
          type="text"
          tracking={false}
          error={errors.cancellation?.departureCountry}
        />
        <Input
          name="cancellation.arrivalCountry"
          control={control}
          labelText="Country of arrival"
          type="text"
          tracking={false}
          error={errors.cancellation?.arrivalCountry}
        />
        <Dropdown
          name="cancellation.reason"
          labelText="Reason for cancellation"
          placeholder="Select an option"
          options={cancellationReasonOptions}
          control={control}
          error={errors.cancellation?.reason}
          tracking={false}
        />
        <InputGroup
          name="cancellation.cancellationOccurence"
          control={control}
          labelText="When did the reason for cancellation occur?"
          options={cancellationOccurance}
          type="radio"
          variant="column"
          error={errors.cancellation?.cancellationOccurence}
          tracking={false}
        />
        <Textarea
          name="detailedIncidentDescription"
          control={control}
          labelText="Describe what happened in detail"
          maxWarning={500}
          error={errors.detailedIncidentDescription}
        />
        <Input
          name="compensation"
          control={control}
          labelText="Add the amount you are seeking compensation for"
          type="text"
          tracking={false}
          error={errors.compensation}
        />
      </Box>
    </>
  );
};

export default Cancellation;
